import { isLocalDev } from "./env";

export const getBookshelfHost = () => {
  if (isLocalDev()) {
    // Local usage would potentially need to SSO for protected content, though
    // it's not very reflective of actual use, so not worried about that.
    return `https://bookshelf-dev.vitalsource.com`;
  } else {
    return "";
  }
};
